module.exports = __webpack_public_path__ + "static/media/concrete-bg.e7c9ea5c.jpg";